export class ClassificaDTO {
  id: string;
  codice: string;
  nome: string;
}
